var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickupPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 1116 0A8 8 0 110 8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2.58 8A2.583 2.583 0 018 10.58 2.584 2.584 0 015.42 8 2.584 2.584 0 018 5.42 2.584 2.584 0 0110.58 8z",
    fill: "#40AE82"
  })));
}
export default SvgPickupPin;